<template>
    <div class="container-fluid mt--7">
        <div class="card mb-3">
            <div class="row no-gutters">   
                <div class="col-md" style="padding: 15px; padding-left: 25px;">
                    <h3 class="mb-3"> Serial Manager</h3>

                    <a-tabs default-active-key="1" type="card" @change="tabChange">
                        <a-tab-pane key="1" tab="Documents">

                        <div class="row">
                            <div class="col-auto mt-1"><h3>Product Search</h3></div>
                            <div class="col-auto pr-0">
                                <a-select :value='_.startCase(serialFilter)' style="width: 200px" @change="serialProductFilterChange">
                                    <a-select-option v-for="s in serialSearchFilter" :key="s"> {{_.startCase(s)}}</a-select-option>
                                </a-select>
                            </div>
                            <div class='col pl-1'>
                                <a-input-search style="width: 100%" @search="onSerialSearch" />
                            </div>  
                        </div>

                        <hr class="mb-0 mt-2">
                        
                        <div class="row" style="min-height: 56vh; overflow: auto;">
                            <div class="col-md-3 p-0" style="border-right: 1px solid #e0e0e0">
                                <div class="card-body p-0 mt-2">
                                    <div v-if="filteredProducts.length > 0" class="col">
                                        <h5 class="card-title my-2">Products</h5>  
                                        <a-table rowKey="id" size="small" :customRow="filteredProductEvent" :columns="filteredProductsColumn" :data-source="filteredProducts" />
                                    </div>
                                    <div v-else>
                                        <a-empty class='mt-5' :image-style="{height: '50px',}" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-9 px-0">
                                <div class="card-body p-0 mt-2">
                                    <div v-if="selectedProductSerials.length > 0" class="col">
                                        <h5 class="card-title my-2">Serial Numbers - {{ selectedProduct }} </h5> 
                                        <a-table rowKey="id" size="small" :customRow="serialRecordsEvent" :columns="selectedProductColumn" :data-source="selectedProductSerials" />
                                    </div>
                                    <div v-else >
                                        <a-empty class='mt-5' :image-style="{height: '60px',}" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        </a-tab-pane>
                        <a-tab-pane key="2" tab="Pending Documents">
                            <a-table rowKey="id" size="small" :customRow="pendingDocumentsEvent" :columns="pendingDocumentsColumn" :data-source="pendingDocuments" />        
                        </a-tab-pane>
                    </a-tabs>
 
                </div>
            </div>
        </div>

        <a-drawer
            placement="right"
            :width="480"
            :visible="drawerVisible"
            @close="onClose"
            :key="drawerKey"
        >
            <h6 class="heading-small text-muted mb-4 text-truncate">Serial Browser -  {{ selectedSerial.product_name }}</h6>
            <h5 class="card-title my-0">Stock No: {{ selectedSerial.stock_no}}</h5>
            <h5 class="card-title mt-1 mb-2">Barcode: {{ selectedSerial.barcode }}</h5>  
            <a-table rowKey="id" size="small" :customRow="drawerSerialsEvent" :columns="drawerSelectedProductColumn" :data-source="drawerSelectedProductSerials"/>

            <a-modal v-model="modalVisible" @ok="confirmModal">
                <h6 class="heading-small text-muted mb-4 text-truncate">Enter a new serial number</h6>
                <a-input placeholder="Enter New Serial" v-model="newSerial" />
            </a-modal>

            <div :style="{
                position: 'absolute',
                right: 0,
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e9e9e9',
                padding: '10px 16px',
                background: '#fff',
                textAlign: 'right',
                zIndex: 1,
                }"
            >

                <a-popconfirm title="Are you sure you want to continue?" @confirm="saveSerialDrawerChanges" okText="Yes" cancelText="Cancel">
                    <a-button type="primary" block>Save</a-button>
                </a-popconfirm>                
            </div>

        </a-drawer>
    </div>
</template>


<script>
    import { mapState, mapActions } from 'vuex'
    import HTTPRequest from '../../controllers/httpRequest.js'
    export default {
        data: function () {
            return {
                pendingDocuments: [],
                pendingDocumentsColumn: [
                    {
                        title: 'Site Name',
                        dataIndex: 'site_id.label',
                    },
                    {
                        title: 'Document',
                        dataIndex: 'document_name',
                    },
                    {
                        title: 'Document #',
                        dataIndex: 'id',
                    },
                    {
                        title: 'Document Date',
                        dataIndex: 'document_date',
                    }
                ],
                newSerial: '',
                modalVisible: false,
                drawerVisible: false,
                serialSearchFilter: ['serial_no', 'name', 'stock_no', 'reference_code', 'barcode', 'shelf_code'],
                serialFilter: 'serial_no',
                filteredProducts: [], 
                filteredProductsColumn: [
                    {
                        title: 'Stock No',
                        dataIndex: 'stock_no',
                    },
                    {
                        title: 'Product Name',
                        dataIndex: 'product_name',
                    }
                ],
                selectedProduct: null,
                selectedProductSerials: [],
                selectedProductColumn: [
                    {
                        title: 'Serial Number',
                        dataIndex: 'serial_no',
                    },
                    {
                        title: 'Stock No',
                        dataIndex: 'stock_no',
                    },
                    {
                        title: 'Barcode',
                        dataIndex: 'barcode',
                    },
                    {
                        title: 'Site Name',
                        dataIndex: 'site_name',
                    },
                    {
                        title: 'Document',
                        dataIndex: 'document_name',
                    },
                    {
                        title: 'Document#',
                        dataIndex: 'refcode',
                    },
                    {
                        title: 'Document Date',
                        dataIndex: 'document_date',
                    },

                ],
                selectedSerial: {},
                drawerSelectedProductSerials: [],
                drawerKey: 0,
                drawerSelectedProductColumn: [
                    {
                        title: 'Original Serial Number',
                        dataIndex: 'serial_no',
                    },
                    {
                        title: 'New Serial Number',
                        dataIndex: 'new_serial_no',
                    },
                    {
                        title: 'Status',
                        dataIndex: 'status',
                    }

                ],
            }
        },
        mounted: async function(){
            
        },
        computed: {
            ...mapState(['endPoint', 'publicUrl'])
        },
        methods:{
            pendingDocumentsEvent(record) {
                return {
                    on: {
                        click: event => {
                            this.$router.push({name: 'document_form', params: { id: record.id }});
                        }
                    }
                };
            },
            async saveSerialDrawerChanges(){
                var payload = {inventory_serials: this.drawerSelectedProductSerials}
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'documents/process_serial_manager_new_serial', null, payload)
                if (post_request.msg = "SUCCESS") {
                    this.onClose()
                    this.retrieveProductSerials(this.selectedProduct)
                    this.$notification['info']({
                        message: 'Serial Manager',
                        description: "Action completed."
                    });
                } else {
                    this.$notification['info']({
                        message: 'Serial Manager',
                        description: "There is an errror processing this request."
                    });
                }
            },
            confirmModal(){ 
                this.drawerSelectedProductSerials.find(x => x.id == this.selectedSerial.id).new_serial_no = this.newSerial
                this.modalVisible = false;
            },
            showModal(record) {
                this.newSerial = record.serial_no
                this.modalVisible = true;
            },
            showDrawer(record) {
                this.drawerKey++;
                this.drawerVisible = true;
                this.selectedSerial = record;
                this.drawerSelectedProductSerials = this.selectedProductSerials.filter(item => item.site_id == record.site_id) 
                this.drawerSelectedProductSerials = this.selectedProductSerials.filter(item => item.status == "A")              
            },
            onClose() {
                this.drawerVisible = false;
            },
            drawerSerialsEvent(record) {
                return {
                    on: {
                        click: event => {
                            this.editSerial(record)
                        }
                    }
                };
            },
            editSerial(record){
                this.showModal(record);
            },
            serialRecordsEvent(record) {
                return {
                    on: {
                        click: event => {
                            this.showDrawer(record)
                        }
                    }
                };
            },
            filteredProductEvent(record) {
                return {
                    on: {
                        click: event => {
                            this.retrieveProductSerials(record)
                        }
                    }
                };
            },
            async retrieveProductSerials(record){
                this.selectedProduct = record.product_name
                var selected_product_serials = await HTTPRequest.getRequest(this.endPoint + 'inventory_serials?product_id='+record.product_id, null, null)
                this.selectedProductSerials = selected_product_serials.data
            },
            async tabChange(activeKey){
                if (activeKey == 2) {
                    this.pendingDocuments = []
                    var pending_documents = await HTTPRequest.getRequest(this.endPoint + 'documents/pending_physical_count', null, null)
                    this.pendingDocuments = pending_documents
                }
            },
            serialProductFilterChange(value){
                this.serialFilter = value;
            },
            async onSerialSearch(value){
                this.filteredProducts = []
                this.selectedProductSerials = []
                if (this.serialFilter == 'serial_no') {
                    var filtered_products = await HTTPRequest.getRequest(this.endPoint + 'inventory_serials?distinct_products=1&serial_no='+value, null, null)
                    this.filteredProducts = filtered_products.data
                } else {
                    var filtered_products = await HTTPRequest.getRequest(this.endPoint + 'products/serial_manager_products?field='+this.serialFilter+'&value='+value, null, null)
                    this.filteredProducts = filtered_products
                }
            },
        }
    }
</script>

<style>
</style>